export function IconNewsletterArrow(props: {
  className?: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      aria-label="Submit Newsletter"
    >
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
      >
        <path d="M0 8.00024H15.4997V6.00056H0V8.00024Z" fill="currentColor" />
        <path
          d="M11.2003 0.299603L9.79971 1.70022L15.1004 6.9999L9.79971 12.2996L11.2003 13.7002L17.8997 6.99988L11.2003 0.299603Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}
